import { Component, OnInit, Input } from '@angular/core';
import { AddProductCartComponent } from 'src/app/elements/add-product-cart/add-product-cart.component';
import { MatDialog } from '@angular/material/dialog'
import { Product } from 'src/app/entities/product';
import { slugify } from 'src/app/utils/string.utils';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit {

  @Input() product = new Product();

  constructor(public dialog: MatDialog) { }

  ngOnInit() {
  }

  getPrice() {
    return Product.getPrice(this.product);
  }

  getPriceTwo() {
    return Product.getPriceTwo(this.product);
  }

  getPriceWithoutDiscount() {
    return Product.getPriceWithoutDiscount(this.product);
  }

  getDiscount() {
    return Product.getDiscount(this.product);
  }

  getStock() {
    return Product.getStock(this.product);
  }

  hasRibbon(): boolean {
    if (this.product.ribbon != '' && this.product.ribbon != null && this.product.ribbon != undefined) {
      return true;
    }
    return false;
  }

  processTitle() {
    return slugify(this.product.title);
  }

  addProductCart(): void {
    this.dialog.open(AddProductCartComponent, {
      width: '400px',
      data: { product: this.product }
    });
  }

  status: boolean = true;
  addProductActive(){
    this.status = !this.status;       
  }

  viewMountCard(): void {
    this.dialog.open(AddProductCartComponent, {
      width: '400px',
      data: { product: this.product }
    });
  }
}
